import type { Resource } from '../../';
export const product_sizeChart_category_bigKids: Resource = {"default":"Big Kids"};
